// ConfidentialityAnimation.js
import React from "react";
import Lottie from "react-lottie";
import confidentialityAnimation from "./animations/confidentiality.json"; // Adjust the path as needed

const ConfidentialityAnimation = () => {
  const defaultOptions = {
    loop: true, // Animation will replay continuously
    autoplay: true,
    animationData: confidentialityAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}>
      <Lottie options={defaultOptions} height={400} width={400} />
    </div>
  );
};

export default ConfidentialityAnimation;
